'use client';
import Setting from '@/app/_components/ui/icons/Setting.svg';
import SearchList from '@/app/_components/ui/icons/SearchList.svg';
import { useRouterParams } from '@/app/_hooks/useRouterParams';
import { useIsMobile } from '@/app/_hooks/useIsMobile';
import PriceList from '@/app/_components/ui/icons/PriceList.svg';
import Excel from '@/app/_components/ui/icons/Excel.svg';
import Print from '@/app/_components/ui/icons/Print.svg';
import PdfInvoice from '@/app/_components/ui/icons/PdfInvoice.svg';

export default function SortFilter({
  sort,
  setOpenMobileSide,
  isPriceList,
  setIsPriceList,
}) {
  const { setParam } = useRouterParams();
  const isMobile = useIsMobile();

  const changeSort = (sortValue) => {
    setParam('sort', sortValue);
  };

  const sortList = [
    {
      name: ' ارزان ترین',
      value: 2,
    },
    {
      name: ' گرانترین',
      value: 1,
    },
    {
      name: ' پرفروش ترین',
      value: 3,
    },
    {
      name: ' محبوب ترین',
      value: 5,
    },
  ];

  return (
    <div className="flex justify-between ">
      {!isMobile ? (
        <div className="sort-products flex pb-6 ">
          <Setting />
          <span className="text-balck-primary text-sm pr-2">
            مرتب سازی بر اساس:
          </span>
          <ul className="flex">
            {sortList.map((sortItem, index) => (
              <li
                className={
                  'px-2 text-sm  cursor-pointer' +
                  (sort == sortItem.value
                    ? ' text-ocean-blue font-medium'
                    : ' text-gray-100')
                }
                onClick={() => changeSort(sortItem.value)}
                key={index}
              >
                <span>{sortItem.name}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="w-full">
          <div className="form-check text-sm form-switch inline-flex justify-between h-fit items-center">
            <PriceList />
            <span className="px-2">لیست قیمت </span>
            <input
              className="form-check-input appearance-none w-9 ml-2 text-sm  rounded-full  h-5 align-top  bg-no-repeat bg-contain bg-gray-300 focus:outline-none cursor-pointer shadow-sm"
              type="checkbox"
              role="switch"
              checked={isPriceList}
              onChange={(e) => setIsPriceList(e.target.checked)}
            />
          </div>

          <div className="sort-products flex w-full flex-wrap items-center mb-3 justify-between w-full md:w-auto border border-light-gray-150 rounded-md ">
            <div className="w-1/2 my-2 px-2">
              <div
                className="flex items-center text-sm gap-2 "
                onClick={setOpenMobileSide}
              >
                <SearchList />
                <span> جستجو پیشرفته</span>
              </div>
            </div>
            <div className="my-2 w-1/2 ">
              <div className="flex items-center text-sm gap-2 justify-end">
                <Setting
                  onClick={() => setShowSortOption((prevCheck) => !prevCheck)}
                />
                <select
                  className="p-0 pr-1 pl-2 border-none bg-transparent focus:ring-0 text-xs "
                  onChange={(event) => changeSort(event.target.value)}
                >
                  {sortList.map((sortItem, index) => (
                    <option value={sortItem.value} key={index} className="px-2">
                      {sortItem.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isMobile && (
        <div className="form-check text-sm form-switch flex justify-between h-fit items-center">
          <PriceList />
          <span className="px-2">لیست قیمت </span>
          <input
            className="form-check-input appearance-none w-9 ml-2 text-sm  rounded-full  h-5 align-top  bg-no-repeat bg-contain bg-gray-300 focus:outline-none cursor-pointer shadow-sm"
            type="checkbox"
            role="switch"
            checked={isPriceList}
            onChange={(e) => setIsPriceList(e.target.checked)}
          />
        </div>
      )}
    </div>
  );
}
